export default __webpack_public_path__ + "static/media/dr-poojitha-cutis.c18b2ce5.jpg";